<div class="c-alert-dialog" (click)="backdropDismiss()">
  <div class="c-alert-dialog__wrapper" (click)="$event.stopPropagation()">
    <div class="c-alert-dialog__title">
      {{ title }}
    </div>
    <div class="c-alert-dialog__description">
      {{ message }}
    </div>
    @if (buttons.length > 0) {
      <div class="c-alert-dialog__buttons">
        @for (button of buttons; track button) {
          <button
            class="c-alert-dialog__button"
            [class.c-alert-dialog__button--cancel]="button.role === 'cancel'"
            [class.c-alert-dialog__button--danger]="button.role === 'danger'"
            (click)="callHandler(button.handler)"
          >
            {{ button.text }}
            @if (button.icon) {
              <ion-icon [name]="button.icon"></ion-icon>
            }
          </button>
        }
      </div>
    }
  </div>
</div>
